import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canAccessSeguimientoCesionesFacturacion } from '../utils/gestionCampanaAccess'

const RequireSeguimientoCesionesFacturacionAccess = ({ children }) => {
  const { user } = useUser()
  if (!canAccessSeguimientoCesionesFacturacion(user)) {
    return <Navigate to="/inicio" replace />
  }
  return children
}

export default RequireSeguimientoCesionesFacturacionAccess
